import axios from 'axios';
import { TIME_10000 } from '@/shared/constants/services-const';
import handlerErrorFromApis from './errorHandler';

const createApiInstance = (baseURL) => {
    return axios.create({
        baseURL: baseURL,
        timeout: TIME_10000,
    });
};

const userApiInstance = createApiInstance(process.env.VUE_APP_AUTH_API);
const sportsApiInstance = createApiInstance(process.env.VUE_APP_CLICK_API);
const fantasyApiInstance = createApiInstance(process.env.VUE_APP_FANTACY_API);
const walletApiInstance = createApiInstance(process.env.VUE_APP_GET_ID_WALLET);
const bonusApiInstance = createApiInstance(process.env.VUE_APP_BONUS_API);
const notificationApiInstance = createApiInstance(process.env.VUE_APP_NOTIFICATION_API);
const walletConigApiInstance = createApiInstance(process.env.VUE_APP_GET_ID_WALLET_CONFIG);
const walletRequestApiInstance = createApiInstance(process.env.VUE_APP_GET_ID_WALLET_REQUEST);
const chatApiInstance = createApiInstance(process.env.VUE_APP_CHAT_API);



const apiInstances = {
    user: userApiInstance,
    sports: sportsApiInstance,
    fantasy: fantasyApiInstance,
    wallet: walletApiInstance,
    bonus: bonusApiInstance,
    notification: notificationApiInstance,
    walletConfig: walletConigApiInstance,
    walletRequest: walletRequestApiInstance,
    chat:chatApiInstance

}

Object.values(apiInstances).forEach(instance => {
    instance.interceptors.response.use(
        response => Promise.resolve(response),
        error => handlerErrorFromApis(error)
    );
});

export default apiInstances;